var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pixi-wrapper"},[_c('div',{ref:"pixi-instance",staticClass:"pixi-instance",on:{"dragenter":function($event){$event.preventDefault();_vm.onDragEnter($event)},"drop":function($event){$event.preventDefault();_vm.onDrop($event)},"dragover":function($event){$event.preventDefault();_vm.onDragOver($event)}}}),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0e555786","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./assets/vue/apps/participate/pixi-stage.vue
// module id = 345
// module chunks = 0 1